import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/public/icons/industriaIcon.png");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/public/icons/location marker with shadow - dark.png");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/public/icons/location marker with shadow - light.png");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/public/images/contact-us/BCI_2025Logo_Vertical_FullColor.png");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/public/images/contact-us/BEI_2025Logo_Horizontal_FullColor.png");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/public/images/contact-us/DLElectric_2025Logo_FullColor.png");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/public/images/contact-us/Industria_CompanyMap_MapBG 1.png");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/public/images/contact-us/JSET_Logo.png");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/public/images/contact-us/MKD LOGO.png");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/public/images/contact-us/Powercor_Logo.png");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/public/images/contact-us/SEATAC_Logo_Color.png");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/public/images/contact-us/Wesa Automation Logo.png");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/public/images/contact-us/XSTelecom_2025Logo_Black.png");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/components/ContactForm.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/components/ScrollButton.js");
